import { registerComponent } from '@gig/magic-common';
import KeycloakThemeComponent from './keycloak-theme.vue.js';
export { KeycloakLogin } from './components/login/index.js';
export { KeycloakUpdatePassword } from './components/update-password/index.js';
export { KeycloakResetPassword } from './components/reset-password/index.js';
export { KeycloakTnC } from './components/tnc/index.js';
export { KeycloakError } from './components/error/index.js';
export { KeycloakInfo } from './components/info/index.js';
export { KeycloakTOtp } from './components/totp/index.js';
export { KeycloakLoginExpired } from './components/login-expired/index.js';
export { KeycloakConfigureOtp } from './components/configure-otp/index.js';
export { KeycloakLoginSms } from './components/login-sms/index.js';

var KeycloakTheme = registerComponent(KeycloakThemeComponent);

export { KeycloakTheme };
